import Packlink from '@sdk';
import { IPostalCodeCoordinates, PostalCodesRepository } from '@packlink/packlink-sdk';

export const REJECTION_GEOCODE_ERROR = 'The address provided could not be geocoded.';
export default class LocationsGeoCoder {
    getLatitudeAndLongitudeFor(address: string | undefined, postalCode: string): Promise<IPostalCodeCoordinates> {
        const geoCoder = new google.maps.Geocoder();
        return new Promise((resolve, reject): void => {
            geoCoder.geocode(
                { componentRestrictions: { postalCode }, address },
                (geocodeResults: google.maps.GeocoderResult[] | null, status: google.maps.GeocoderStatus) => {
                    if (status === 'OK' && geocodeResults && geocodeResults.length > 0) {
                        resolve({
                            id: geocodeResults[0].place_id,
                            lat: geocodeResults[0].geometry.location.lat(),
                            lng: geocodeResults[0].geometry.location.lng(),
                        });
                    } else {
                        reject(REJECTION_GEOCODE_ERROR);
                    }
                },
            );
        });
    }

    getPostalCode(alphaCode: string, city: string): Promise<IPostalCodeCoordinates> {
        const postalCodesRepository = new PostalCodesRepository(Packlink.apiClient);
        return postalCodesRepository.getPostalCodeCoordinates(alphaCode, city);
    }
}
